module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("2JMBR"))).then(() => parcelRequire('ia22Z'));